import React, { useLayoutEffect, useState } from "react";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import loadTicketsArray from "../../shared/functions/loadTicketsArray";
import TicketsSideBar from "../components/Sidebar/TicketsSideBar";
import TicketsSideBarMobileChecker from "../components/Sidebar/TicketsSideBarMobileChecker";
import Informer from "../../shared/components/Informer/Informer";
import VideoSectionRandom from "../../video-section/VideoSectionRandom";
import ErrorLoadData from "../../errorPages/ErrorLoadData";

import Ticket from "../components/Ticket";
import "../../App.css";
import Loader from "../../shared/components/Loader";

const NewQuestionsMode = (props) => {

  const { categoryTickets, setLoadedBilet } = props;

  const [isDataRecived, setIsDataRecived] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useLayoutEffect(() => {
    const myfunc = async () => {
      try {
        setLoading(true);
        const loadTickets = await loadTicketsArray(categoryTickets);

        const arrWithNewQuestionsAB = [
          { ticketId: "1", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "3", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "4", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "6", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "7", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "10", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "14", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "22", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "24", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "25", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "26", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "28", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "35", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "37", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "39", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "2", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "6", tasksId: "13", label: "с 1 марта 2023" },
          { ticketId: "7", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "11", tasksId: "1", label: "с 1 марта 2023" },
          { ticketId: "16", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "18", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "22", tasksId: "2", label: "с 1 марта 2023" },
          { ticketId: "25", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "27", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "27", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "28", tasksId: "5", label: "с 1 марта 2023" },
          { ticketId: "29", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "30", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "1", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "8", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "34", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "36", tasksId: "5", label: "с 1 марта 2023" },
          { ticketId: "37", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "38", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "39", tasksId: "11", label: "с 1 марта 2023" },
        ];

        const arrWithNewQuestionsCD = [
          { ticketId: "1", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "4", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "5", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "6", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "7", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "12", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "14", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "22", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "25", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "26", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "28", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "35", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "37", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "39", tasksId: "18", label: "с 1 сентября 2023" },
          { ticketId: "11", tasksId: "1", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "1", label: "с 1 марта 2023" },
          { ticketId: "7", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "30", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "18", tasksId: "3", label: "с 1 марта 2023" },
          { ticketId: "22", tasksId: "2", label: "с 1 марта 2023" },
          { ticketId: "22", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "25", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "27", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "8", label: "с 1 марта 2023" },
          { ticketId: "29", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "36", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "2", tasksId: "6", label: "с 1 марта 2023" },
          { ticketId: "5", tasksId: "10", label: "с 1 марта 2023" },
          { ticketId: "6", tasksId: "10", label: "с 1 марта 2023" },
          { ticketId: "25", tasksId: "10", label: "с 1 марта 2023" },
          { ticketId: "10", tasksId: "12", label: "с 1 марта 2023" },
          { ticketId: "6", tasksId: "13", label: "с 1 марта 2023" },
          { ticketId: "16", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "32", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "36", tasksId: "5", label: "с 1 марта 2023" },
          { ticketId: "38", tasksId: "17", label: "с 1 марта 2023" },
          { ticketId: "39", tasksId: "11", label: "с 1 марта 2023" },
        ]

        const getNewQuestions = (arrWithNewQuestions) => {
          const newQuestions = [];
          for (let i = 0; i < arrWithNewQuestions.length; i++) {
            for (let j = 0; j < loadTickets.length; j++) {
              if (loadTickets[j].ticketId === arrWithNewQuestions[i].ticketId) {
                for (let k = 0; k < loadTickets[j].tasks.length; k++) {
                  if (loadTickets[j].tasks[k].taskId === arrWithNewQuestions[i].tasksId) {
                    newQuestions.push({
                      ...loadTickets[j].tasks[k],
                      ticketId: parseInt(loadTickets[j].ticketId),
                      taskId: (i + 1).toString(),
                      realTaskId: loadTickets[j].tasks[k].taskId,
                      label: arrWithNewQuestions[i].label
                    });
                  }
                }
              }
            }
          }
          return newQuestions;
        }

        const arrWithNewQuestions = categoryTickets === "newAB" ? arrWithNewQuestionsAB : arrWithNewQuestionsCD;

        const newHeader = categoryTickets === "newAB" ? `Новые вопросы AB` : `Новые вопросы CD`;

        const newQuestions = getNewQuestions(arrWithNewQuestions);

        const newBilet = {
          header: newHeader,
          tasks: newQuestions
        }

        setLoadedBilet(newBilet);
        setIsDataRecived(true);
        setLoading(false);
      }
      catch (error) {
        setError(true);
        setLoading(false);
        setIsDataRecived(false);
      }
    }

    myfunc()

  }, [categoryTickets, setLoadedBilet]);

  return (
    <>
      {error && <ErrorLoadData />}
      {loading && <Loader loadingTickets={true} />}
      {isDataRecived && props.loadedBilet &&
        <div className="grid-container">
          <div className="dash-board">
            <Ticket
              currentTicket={props.loadedBilet}
              categoryTickets={props.categoryTickets}
            />
            <div className="adblock-after-task">
              <div id="yandex_rtb_R-A-1691059-3"></div>
              <script>{window.yaContextCb.push(() => {
                window.Ya.Context.AdvManager.render({
                  renderTo: 'yandex_rtb_R-A-1691059-3',
                  blockId: 'R-A-1691059-3'
                })
              })}</script>
            </div>

           {/*  <div className="adblock-after-task-only-mobile">
              <div id="yandex_rtb_R-A-1691059-2"></div>
              <script>{window.yaContextCb.push(() => {
                window.Ya.Context.AdvManager.render({
                  renderTo: 'yandex_rtb_R-A-1691059-2',
                  blockId: 'R-A-1691059-2'
                })
              })}</script>
            </div> */}

          </div>

          <div className="side-bar">
            <TicketsSideBarMobileChecker he={props.loadedBilet.header}>
              {(params) =>
                params ? (
                  <TicketsSideBar
                    ticketsArray={props.ticketsArray}
                    categoryTickets={props.categoryTickets}
                    closeSideBarMobile={params.closeDrawerHandler}
                  />
                ) : (
                  <div className="side-bar">
                    {
                      <TicketsSideBar
                        ticketsArray={props.ticketsArray}
                        categoryTickets={props.categoryTickets}
                      />}
                    <div style={{ maxHeight: "510px" }} className="my-2">
                      <div id="yandex_rtb_R-A-1691059-5"></div>
                      <script>{window.yaContextCb.push(() => {
                        window.Ya.Context.AdvManager.render({
                          renderTo: 'yandex_rtb_R-A-1691059-5',
                          blockId: 'R-A-1691059-5'
                        })
                      })}</script>
                    </div>
                    <Informer />
                  </div>
                )
              }
            </TicketsSideBarMobileChecker>
          </div>

          <div className="video-section-main-page" style={{ marginTop: "2rem" }}>
            <VideoSectionRandom limitForShow={9} />
          </div>

        </div>
      }

    </>

  );
};

const mapStateToProps = (state) => {
  return {
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    ticketsArray: state.ticketsReducer.ticketsArray,
    loadedBilet: state.ticketsReducer.loadedBilet,
    themeMode: state.ticketsReducer.themeMode,
    categoryTickets: state.router.location.pathname.split("/")[1],
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({
        type: actionTypes.RESET_NUMBERS_STATE_ARRAY,
      }),
    setTicketsArray: (ticketsArray) =>
      dispatch({
        type: actionTypes.SET_TICKETS_ARRAY,
        ticketsArray: ticketsArray,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
    debugSET_NUMBERS: (obj) =>
      dispatch({
        type: "SET_NUMBERS_STATE_ARRAY",
        arrayItem: {
          id: obj.id,
          isError: obj.isError,
          clickedAnswer: obj.clickedAnswer,
          ticketId: obj.ticketId,
          taskId: obj.taskId,
        },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewQuestionsMode);
